<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1nm8FF/tc-custom/9780310862550.jpg?1726574123474" alt="This image is the cover for the book I Saw Him in Your Eyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Saw Him in Your Eyes
      </h1>
      <p class="bookDescription body article font2">
        <p>This collection of moving stories reveals the power of ordinary people to shape the lives of others in unexpected, sometimes astonishing ways. Bestselling author Ace Collins presents the inspiring recollections of some of America’s best-loved leaders. These uplifting personal accounts reveal the life-changing impact of a simple kind act, of a good word spoken at the right time, of an everyday life whose unassuming character makes all the difference in someone else’s world.A young woman on a harrowing mission encounters her greatest inspiration during her most fearful time through a humble, seemingly helpless stranger. Today, her organization brings hope to thousands across the world.Mired in a life of addiction, a young man meets three amazing people at key times on his journey to recovery. Today, this award-winning singer and songwriter touches the hearts of thousands through his music.These and other real-life stories will encourage you, uplift you, and fill you with gratitude for those who have touched your own life. And they will cause you to consider your purpose and potential. Today may be the day when your own ordinary life influences someone else in an extraordinary way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ace Collins
      </h2>
      
      <p class="authorDescription body article"><P>Ace Collins is the writer of more than sixty books, including several bestsellers: Stories behind the Best-Loved Songs of Christmas, Stories behind the Great Traditions of Christmas, The Cathedrals, and Lassie: A Dog’s Life. Based in Arkadelphia, Arkansas, He continues to publish several new titles each year, including a series of novels, the first of which is Farraday Road. Ace has appeared on scores of television shows, including CBS This Morning, NBC Nightly News, CNN, Good Morning America, MSNBC, and Entertainment Tonight.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?87925de0